import _inherits from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { SourceNode } from './source';
import { GraticuleNode } from './graticule';
import { SequenceNode } from './sequence';
/**
 * Whether this dataflow node is the source of the dataflow that produces data i.e. a source or a generator.
 */

export function isDataSourceNode(node) {
  return node instanceof SourceNode || node instanceof GraticuleNode || node instanceof SequenceNode;
}
/**
 * Abstract base class for BottomUpOptimizer and TopDownOptimizer.
 * Contains only mutation handling logic. Subclasses need to implement iteration logic.
 */

var OptimizerBase = /*#__PURE__*/function () {
  function OptimizerBase() {
    _classCallCheck(this, OptimizerBase);

    this._mutated = false;
  } // Once true, _mutated is never set to false


  _createClass(OptimizerBase, [{
    key: "setMutated",
    value: function setMutated() {
      this._mutated = true;
    }
  }, {
    key: "mutatedFlag",
    get: function get() {
      return this._mutated;
    }
  }]);

  return OptimizerBase;
}();
/**
 * Starts from a node and runs the optimization function(the "run" method) upwards to the root,
 * depending on the continueFlag and mutatedFlag values returned by the optimization function.
 */


export var BottomUpOptimizer = /*#__PURE__*/function (_OptimizerBase) {
  _inherits(BottomUpOptimizer, _OptimizerBase);

  var _super = _createSuper(BottomUpOptimizer);

  function BottomUpOptimizer() {
    var _this;

    _classCallCheck(this, BottomUpOptimizer);

    _this = _super.call(this);
    _this._continue = false;
    return _this;
  }

  _createClass(BottomUpOptimizer, [{
    key: "setContinue",
    value: function setContinue() {
      this._continue = true;
    }
  }, {
    key: "continueFlag",
    get: function get() {
      return this._continue;
    }
  }, {
    key: "flags",
    get: function get() {
      return {
        continueFlag: this.continueFlag,
        mutatedFlag: this.mutatedFlag
      };
    },
    set: function set(_ref) {
      var continueFlag = _ref.continueFlag,
          mutatedFlag = _ref.mutatedFlag;

      if (continueFlag) {
        this.setContinue();
      }

      if (mutatedFlag) {
        this.setMutated();
      }
    }
    /**
     * Reset the state of the optimizer after it has completed a run from the bottom of the tree to the top.
     */

  }, {
    key: "reset",
    value: function reset() {// do nothing
    }
  }, {
    key: "optimizeNextFromLeaves",
    value: function optimizeNextFromLeaves(node) {
      if (isDataSourceNode(node)) {
        return false;
      }

      var next = node.parent;

      var _this$run = this.run(node),
          continueFlag = _this$run.continueFlag;

      if (continueFlag) {
        this.optimizeNextFromLeaves(next);
      }

      return this.mutatedFlag;
    }
  }]);

  return BottomUpOptimizer;
}(OptimizerBase);
/**
 * The optimizer function( the "run" method), is invoked on the given node and then continues recursively.
 */

export var TopDownOptimizer = /*#__PURE__*/function (_OptimizerBase2) {
  _inherits(TopDownOptimizer, _OptimizerBase2);

  var _super2 = _createSuper(TopDownOptimizer);

  function TopDownOptimizer() {
    _classCallCheck(this, TopDownOptimizer);

    return _super2.apply(this, arguments);
  }

  return _createClass(TopDownOptimizer);
}(OptimizerBase);